<template>
  <div @click="openLangSelector()" class="flex justify-between items-center">
    {{ text }}
    <span
      :class="['flex items-center justify-center font-semibold', {
        'w-8 h-8 text-xl ': size === 'lg',
        'w-6 h-6 text-lg': !size || size === 'md',
        'w-4 h-4 text-base': size === 'sm'
      }]"
    >
      {{ getLangAbbr(systemStore.clientSettings.lang) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { useSystemStore } from '@/stores/systemStore'

defineProps<{
  text?: string
  asModal?: boolean
  size?: 'lg' | 'md' | 'sm'
}>()

const openLangSelector = inject<() => {}>('app.openLangSelector')

const getLangAbbr = (lang: string) => {
  switch (lang) {
    case 'pt':
      return 'PT'
    case 'en':
      return 'EN'
    case 'es':
      return 'ES'
    default:
      return 'PT'
  }
}

const systemStore = useSystemStore()
</script>

<style lang="postcss" scoped>
.ls-item {
  @apply relative inline-flex items-center p-3 hover:bg-[--c-primary-300] dark:hover:bg-[--c-primary-700] hover:text-[--c-primary-700] dark:hover:text-[--c-primary-300] rounded transition-all cursor-pointer;
}
</style>